import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.conditionTypes.itemsLoading;
export const getItemsSelect = (state:RootState) => state.conditionTypes.dropDownItems;